import { doc } from 'firebase/firestore';

import { AccountBrand } from '@superfunnel/types/account-brand';

import { db } from '../Firebase';
import { emptyConverter } from '../utils';

export const getAccountBrandDocRef = (accountId: string) =>
  doc(db, 'accounts', accountId, 'accountBrand', 'default').withConverter(
    emptyConverter<AccountBrand>(),
  );
